// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3bX-C","buttons":"PendingPaymentAlert_buttons__2y_Li"};